import { TranslateService } from '@ngx-translate/core';
import { LokaliseTranslateService } from './lokalise-translate.service';
import { LokaliseTranslatePipe } from './lokalise-translate.pipe';
import { NgModule } from '@angular/core';

export * from './provider';
export * from './lokalise-translate.pipe';

export const lokaliseOverrideTranslateService = {
  provide: TranslateService,
  useClass: LokaliseTranslateService,
};

@NgModule({
  providers: [lokaliseOverrideTranslateService],
  imports: [LokaliseTranslatePipe],
  exports: [LokaliseTranslatePipe]
})
export class LokaliseOverrideModule {}
